import { render, staticRenderFns } from "./Archive-Dialog.vue?vue&type=template&id=847efd22"
import script from "./Archive-Dialog.vue?vue&type=script&lang=js"
export * from "./Archive-Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports